/**
 * Deep-link helpers so external flows (e.g. Whop) can open the sign-up form directly.
 *
 * Supported:
 *   - ?register  or  ?register=1  or  ?register=true
 *   - ?signup=1  or  ?signup=true
 *   - /register  path (SPA rewrite loads the same app)
 */

export function isRegisterDeepLink(searchParams, pathname = '') {
  const path = (pathname || '').replace(/\/+$/, '') || '/';
  if (path === '/register' || path.endsWith('/register')) {
    return true;
  }
  if (!searchParams) {
    return false;
  }
  if (searchParams.has('register')) {
    const value = searchParams.get('register');
    if (value === null || value === '' || value === '1' || String(value).toLowerCase() === 'true') {
      return true;
    }
  }
  const signup = searchParams.get('signup');
  if (signup === '1' || String(signup).toLowerCase() === 'true') {
    return true;
  }
  return false;
}

/**
 * If the current URL is a register deep link, strip routing hints from the address bar
 * and return true so the UI should show the register form (not login).
 */
export function parseRegisterDeepLinkFromWindow() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const url = new URL(window.location.href);
    if (!isRegisterDeepLink(url.searchParams, url.pathname)) {
      return false;
    }
    url.searchParams.delete('register');
    url.searchParams.delete('signup');
    if (url.pathname.endsWith('/register')) {
      const base = url.pathname.replace(/\/register\/?$/, '') || '/';
      url.pathname = base;
    }
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    return true;
  } catch {
    return false;
  }
}
